const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'ISSUE_PARTNER_EVALUATION_REASONS_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
